import apiClient from '@/services/axios';

export async function get() {
  const response = await apiClient.get('/recurringNotifications/');
  if (response) {
    return response.data;
  }
  throw new Error('Unable to get recurring notifications.');
}
